<div class="modal-container">
  <div class="modal-header border-0">
    <div class="site-wide-primary">
      <h1 class="modal-title">{{companySettingHeading.COMPANY_SETTINGS}}</h1>
      <p class="popup-secondary-text text-light-info m-t-5 mb-0">
        Enter your company’s information.
      </p>
    </div>
  </div>
  <!-- Modal Header End -->
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="mb-4">
          <app-input
          [inputLabel]="'Company Name'"
          [inputType]="'text'"
          [inputValue]="companySettingData.companyName"
          (inputValueEmit)="companySettingData.companyName = $event"
          [inputReqValidation]="true"
          [ngClass]="{'border-red': !companySettingData.companyName && submit}"

        >
        </app-input>
  
        </div>
        <div class="mb-4">
          <app-input
          [inputLabel]="'Email Address'"
          [inputType]="'email'"
          [inputValue]="companySettingData.email"
          (inputValueEmit)="companySettingData.email = $event"
          (emailValidityChange)="isEmailInvalid = $event"
          [ngClass]="{'border-red': isEmailInvalid || (isEmailInvalid && submit)}"
        >
        </app-input>
        </div>
        <div class="mb-4">
          <app-input
          [inputLabel]="'Phone Number'"
          [inputType]="'text'"
          [inputValue]="companySettingData.phoneNumber"
          (inputValueEmit)="companySettingData.phoneNumber = $event"
          [inputMaxlength]="14"
          onlyNumbers
        >
        </app-input>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <div class="mb-4">
          <app-input
          [inputLabel]="'Address Line 1'"
          [inputType]="'text'"
          [inputValue]="companySettingData.addressLine1"
          (inputValueEmit)="companySettingData.addressLine1 = $event"
        >
        </app-input>
        </div>
        <div class="mb-4">
          <app-input
          [inputLabel]="'Address Line 2'"
          [inputType]="'text'"
          [inputValue]="companySettingData.addressLine2"
          (inputValueEmit)="companySettingData.addressLine2 = $event"
        >
        </app-input>
        </div>
        <div class="mb-4">
          <app-dropdown
          [selectLabel]="'Country'"
          [data]="countryList"
          [selectValue]="companySettingData.country"
          (selectValueEmit)="companySettingData.country = $event"
          [required]="false"
        >
        </app-dropdown>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <div class="mb-4">
          <app-dropdown
          [selectLabel]="'State/Province'"
          [data]="stateList"
          [selectValue]="companySettingData.state"
          (selectValueEmit)="companySettingData.state = $event"
          [required]="false"
        >
        </app-dropdown>
        </div>
         <div class="mb-4">
          <app-input
          [inputLabel]="'Postal Code'"
          [inputType]="'text'"
          [inputValue]="companySettingData.postalCode"
          (inputValueEmit)="companySettingData.postalCode = $event"
        >
        </app-input>
        </div>
        <div class="mb-4">
          <app-input
          [inputLabel]="'City'"
          [inputType]="'text'"
          [inputValue]="companySettingData.city"
          (inputValueEmit)="companySettingData.city = $event"
        >
        </app-input>
        </div>


      </div>
    </div>
  </div>
  <!-- Modal body End -->
  <div class="modal-footer border-0 d-flex justify-content-end">
    <div class="m-0 d-flex gap-3">
      <app-button
      [button_2]="true"
      [buttonClass]="'button button-info popup-button'"
      [buttonLable]="enumButtonName.CANCEL"
      (click)="activeModal.close()"
      >
    </app-button>
    <app-button
    [button_2]="true"
    [buttonClass]="'button button-primary popup-button'"
    [buttonLable]="enumButtonName.SAVE"
    (click)="insertUpdateCompanySettingData()"
    >
  </app-button>
   </div>
  </div>
  <!-- Modal Footer End -->
</div>
